import React from 'react';
import { Route } from 'react-router-dom';
import Schools from '../pages/schools/Schools';
import SchoolsArchive from '../pages/schools/SchoolsArchive';
import CreateSchool from '../pages/schools/CreateSchool';
import EditSchool from '../pages/schools/EditSchool';
import PermissionGuard from '../components/global/PermissionGuard';

const schoolsRoutes = (
    <>
        <Route
            path="/schools"
            element={
                <PermissionGuard permission="schools_list">
                    <Schools />
                </PermissionGuard>
            }
        />

        <Route
            path="/schools/archive"
            element={
                <PermissionGuard permission="schools_archive_list">
                    <SchoolsArchive />
                </PermissionGuard>
            }
        />

        <Route
            path="/schools/create"
            element={
                <PermissionGuard permission="schools_create">
                    <CreateSchool />
                </PermissionGuard>
            }
        />

        <Route
            path="/schools/:id/edit"
            element={
                <PermissionGuard permission="schools_edit">
                    <EditSchool />
                </PermissionGuard>
            }
        />
    </>
);

export default schoolsRoutes;
